@switch (context ? context.type : '') {
    @default {
        <fui-edit-more-input (focussed$)="onFocussed($event)"></fui-edit-more-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-more-input [control]="control" [disabled]="disabled" [field]="valueField"
                               (focussed$)="onFocussed($event)" #input [key]="labelField" [label]="label"
                               [(ngModel)]="value" [options]="options"
                               [placeholder]="placeholder">
            @if (icon) {
                <fui-icon [icon]="icon" [height]="iconSize" [width]="iconSize"></fui-icon>
            }
        </fui-filter-more-input>
    }
    @case (contextType.HEADER) {
        <fui-header-more-input [control]="control" [disabled]="disabled" [field]="valueField"
                               (focussed$)="onFocussed($event)" #input [key]="labelField" [label]="label"
                               [(ngModel)]="value" [options]="options"
                               [placeholder]="placeholder">
            @if (icon) {
                <fui-icon [icon]="icon" [height]="iconSize" [width]="iconSize"></fui-icon>
            }
        </fui-header-more-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-more-input (focussed$)="onFocussed($event)"></fui-inline-more-input>
    }
    @case (contextType.PILL) {
        <fui-more-pill (focussed$)="onFocussed($event)"></fui-more-pill>
    }
    @case (contextType.POP) {
        <fui-pop-more-input (focussed$)="onFocussed($event)"></fui-pop-more-input>
    }
}
